import { render, staticRenderFns } from "./activeListDefault.vue?vue&type=template&id=89c43212&scoped=true"
import script from "./activeListDefault.vue?vue&type=script&lang=js"
export * from "./activeListDefault.vue?vue&type=script&lang=js"
import style0 from "./activeListDefault.vue?vue&type=style&index=0&id=89c43212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c43212",
  null
  
)

export default component.exports